import { observer } from 'mobx-react'
import ContentState from '../../../stores/ContentState'
import './index.scss'
import { ReactComponent as SliderArrow } from '../../../assets/news/Rectangle 28.svg'
import img1 from '../../../assets/terminals/grid.svg'
import img from '../../../assets/terminals/home.svg'
import img2 from '../../../assets/terminals/maximize.svg'
import GlobalState from '../../../stores/GlobalState'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import Map from '../../common/Map/Map'

const TerminalCol = observer(
  ({ dt, setTerm }: { dt: any; setTerm: () => void }) => {
    const [width, setWidth] = useState(window.innerWidth)
    const content = ContentState.terminals
    const getDays = () => {
      if (!GlobalState.currentLocale.lang.includes('En')) {
        return [
          'ПН',
          'ВТ',
          'СР',
          'ЧТ',
          'ПТ',
          'СБ',
          GlobalState.currentLocale.lang.includes('ру') ? 'ВС' : 'НД',
        ]
      }
      return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    }

    useEffect(() => {
      window.addEventListener('resize', () => setWidth(window.innerWidth))
    }, [])

    if (!content) return <></>

    return (
      <section className="terminal-col">
        <div className="terminal-col__back" onClick={setTerm}>
          <SliderArrow /> <span>{content.backTitle}</span>
        </div>
        <div className="terminal-col__title">
          {dt.CityName}, {dt.TypeOfWarehouse}
        </div>
        <div className="terminal-col__subtext">
          {dt.ShortAddress}
          <span>
            {content.siteKey} {dt.siteKey}
          </span>
        </div>
        <div className="terminal-col__row">
          <div className="terminal-col__row-col">
            <div className="terminal-col__row-block">
              <div className="terminal-col__row-top">
                <img src={img} /> {content.typeTitle}
              </div>
              <div className="terminal-col__row-text">{dt.type}</div>
            </div>
            <div className="terminal-col__row-block">
              <div className="terminal-col__row-top">
                <img src={img1} /> {content.weightLimit}
              </div>
              <div className="terminal-col__row-text">
                {content.max} {+dt.TotalMaxWeightAllowed>0? dt.TotalMaxWeightAllowed:dt.PlaceMaxWeightAllowed}{' '}
                {GlobalState.currentLocale.lang.includes('En') ? 'kg' : 'кг'}
              </div>
            </div>
            <div className="terminal-col__row-block">
              <div className="terminal-col__row-top">
                <img src={img2} /> {content.lengthLimit}
              </div>
              <div className="terminal-col__row-text">
                {dt.sendingLimitationsOnDimensions.Width} x{' '}
                {dt.sendingLimitationsOnDimensions.Height} x{' '}
                {dt.sendingLimitationsOnDimensions.Length}
              </div>
            </div>
          </div>
          <div className="terminal-col__row-block">
            <div className="terminal-col__row-top">
              <img src={img} /> {content.additTitle}
            </div>
            <ul className="terminal-col__row-list">
              {dt.services.map((s: any, i: number) => {
                const obj: any = Object.entries(s)
                if (+obj[0][1] != 1) return <></>
                let title = ''
                content?.params?.forEach((d: any) => {
                  if (d.en.trim() == obj[0][0].trim()) {
                    title = d.title
                    return
                  }
                })

                return <li key={i}>{title}</li>
              })}
            </ul>
          </div>
        </div>
        {width > 700 && (
          <table className="terminal-col__table">
            <thead>
              <th></th>
              {getDays().map((c, i) => (
                <th
                  key={i}
                  className={classNames(
                    'terminal-col__table-title',
                    (i == 5 || i == 6) && 'red',
                  )}
                >
                  {c}
                </th>
              ))}
            </thead>
            <tr>
              <td className="terminal-col__table-title">
                {content.columns ? content.columns[0] : content.columns}
              </td>
              {Object.entries(dt.Schedule).map((d: any, i: number) => {
                return (
                  <td className="terminal-col__table-text" key={i}>
                    {d[1]}
                  </td>
                )
              })}
            </tr>
            <tr>
              <td className="terminal-col__table-title">
                {content.columns?.length > 1 && content.columns[1]}
              </td>
              {Object.entries(dt.Delivery).map((d: any, i: number) => {
                return (
                  <td className="terminal-col__table-text" key={i}>
                    {d[1].split('-')[1]?.length?content.max:''} {d[1].split('-')[1]}
                  </td>
                )
              })}
            </tr>
            <tr>
              <td className="terminal-col__table-title">
                {content.columns?.length > 1 && content.columns[2]}
              </td>
              {Object.entries(dt.Reception).map((d: any, i: number) => {
                return (
                  <td className="terminal-col__table-text" key={i}>
                    {d[1].split('-')[0]?.length?content.min:''} {d[1].split('-')[0]}
                  </td>
                )
              })}
            </tr>
          </table>
        )}

        {width <= 700 && (
          <table className="terminal-col__table">
            <thead>
              <th></th>
              {content.columns?.map((ts: any, i: number) => (
                <th className="terminal-col__table-title" key={i}>
                  {ts}
                </th>
              ))}
            </thead>
            {getDays().map((m, i) => {
              const shedule = Object.entries(dt.Schedule)
              const delivery = Object.entries(dt.Schedule)
              const reception = Object.entries(dt.Schedule)

              const shItem:any = shedule[i][1],
                delItem:any = delivery[i][1],
                recItem:any = reception[i][1]

              return (
                <tr key={i}>
                  <td
                    className={classNames(
                      'terminal-col__table-title',
                      (i == 5 || i == 6) && 'red',
                    )}
                  >
                    {m}
                  </td>
                  <td className="terminal-col__table-text">{shItem}</td>
                  <td className="terminal-col__table-text">{delItem}</td>
                  <td className="terminal-col__table-text">{recItem}</td>
                </tr>
              )
            })}
          </table>
        )}
        <div className="terminal-col__map">
          <Map
            center={{
              lat: +dt.lat,
              lng: +dt.lng,
            }}
            zoom={17}
            showMarker={true}
            coords={[
              {
                lat: +dt.lat,
                lng: +dt.lng,
              },
            ]}
          />
        </div>
      </section>
    )
  },
)

export default TerminalCol
